/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';

export const createGroupMember = (startDate, endDate) => {
    const groupMember = {};
    if (startDate) {
        groupMember.start_date = startDate;
    }
    if (endDate) {
        groupMember.end_date = endDate;
    }
    return groupMember;
};

export const setGroupDetails = (groupSize, launchDetail) => {
    const groupMembers = [];
    const { entryDate, exitDate } = launchDetail;

    for (let i = 0; i < groupSize; i += 1) {
        const groupMember = createGroupMember(entryDate, exitDate);
        groupMembers.push(groupMember);
    }
    return groupMembers;
};

// Week of boundary waters is from Sat-Fri and day(0) => sunday
// of the Sun-Sat week the date is within so this will calculate
// the Sat-Fri week range the entrance date is within
export const computeWeekRange = (entryDate) => {
    let startOfWeek = gnoment(entryDate.utc()).day(6);

    // get default start/end date, sat/fri
    if (!entryDate.isSame(startOfWeek)) {
        startOfWeek = gnoment(entryDate).day(0).add(-1, 'day');
    }
    let endOfWeek = gnoment(startOfWeek).add(6, 'day');

    // if end of week
    if (endOfWeek.month() === 9 && startOfWeek.month() === 8) {
        endOfWeek = gnoment(endOfWeek).set('month', 8).set('date', 30);
    }

    // if start of week may 1, use may 1
    if (startOfWeek.month() === 3 && startOfWeek.clone().add(6, 'day').month() === 4) {
        startOfWeek = gnoment(entryDate).set('month', 4).set('date', 1);
    }

    return {
        start: startOfWeek,
        end: endOfWeek,
    };
};
